// extracted by mini-css-extract-plugin
module.exports = {"centeredContainer":"Shop_centeredContainer__1wIe7"};